import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AdvancedMapPinType } from '../../../models/advancedMap.model';
import { BuildingPopupDto } from '../../../models/building-map.model';
import { DtPopupDto } from '../../../models/dt-map.model';
import { PolePopupDto } from '../../../models/pole-map.model';
import { DtService } from '../../../services/dt.service';
import { BuildingService } from '../../../services/building.service';
import { PoleService } from '../../../services/pole.service';
import { AiUploadBatchObjectsService } from '../../../services/ai-upload-batch-objects.service';
import { ArrowTooltipDirective } from '../../../directives/arrow-tooltip.directive';
import { ToastrService } from 'ngx-toastr';
import { CimSubstationPopupDto } from 'src/app/models/cim-substation-map.model';
import { SubstationService } from 'src/app/services/substation.service';
import { TaggedSubstationService } from 'shared-lib';

@Component({
  standalone: true,
  selector: 'app-map-info-window',
  templateUrl: './map-info-window.component.html',
  styleUrls: ['./map-info-window.component.scss'],
  imports: [CommonModule, ArrowTooltipDirective]
})
export class MapInfoWindowComponent implements OnInit {
  @Input() assetId!: number;
  @Input() type!: AdvancedMapPinType;
  @Output() imageClicked = new EventEmitter<string>();

  @Output() actionClicked = new EventEmitter<void>();
  @Output() closeWindow = new EventEmitter<void>();
  @Output() copyCoordinates = new EventEmitter<void>();
  @Output() generatedObjectUrl = new EventEmitter<string | null>();
  @Output() editLocation = new EventEmitter<PolePopupDto>();

  buildingPopup?: BuildingPopupDto;
  dtPopup?: DtPopupDto;
  polePopup?: PolePopupDto;
  cimSubstationPopup?: CimSubstationPopupDto;
  objPopup?: any;
  activeView: 'details' | 'schematic' | '3d' = 'details';

  coordinatesCopied: boolean = false;

  constructor(
    private buildingService: BuildingService,
    private dtService: DtService,
    private poleService: PoleService,
    private taggedSubstationService: TaggedSubstationService,
    private cd: ChangeDetectorRef,
    private batchObjService:AiUploadBatchObjectsService,
    private toastr:ToastrService
  ) { }

  ngOnInit(): void {
    if (this.type == AdvancedMapPinType.Building) {
      this.buildingService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.buildingPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.Dt) {
      this.dtService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.dtPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.Pole) {
      this.poleService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.polePopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.BatchObject) {
      this.batchObjService.getMapDetails(this.assetId).subscribe({
        next: (response: any) => {
          this.objPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      }
      );
    } else if (this.type == AdvancedMapPinType.CimTransmissionStation || 
               this.type == AdvancedMapPinType.CimInjectionSubstation ||
               this.type == AdvancedMapPinType.CimDistributionSubstation
    ) {
      this.taggedSubstationService.getPopupInfo(this.assetId).subscribe({
        next: (response: any) => {
          this.cimSubstationPopup = response.body?.data;
        },
        error: () => {
          console.log('Error occured.');
        }
      });
    }
  }

  selectDetailsView(view: string) {
    this.activeView = view as 'details' | 'schematic' | '3d';
    if(this.activeView == '3d'){
      if(this.objPopup.generatedObjectUrl != null){
        this.generatedObjectUrl.emit(this.objPopup.generatedObjectUrl);
      }else{
        this.toastr.warning('No generated object available for this asset.');
      } 
      this.cd.detectChanges();
    }
  }

  onAction() {
    this.actionClicked.emit();
  }

  onCloseWindow() {
    this.closeWindow.emit();
  }
  onImageClick(imageUrl: string) {
     this.imageClicked.emit(imageUrl);
  }
  onCopyCoordinates() {
    this.coordinatesCopied = true;
    this.cd.detectChanges();
    setTimeout(() => {
      this.coordinatesCopied = false;
      this.cd.detectChanges();
    }, 1500)
    this.copyCoordinates.emit();
  }

  getCoordinateString(latitude: number, longitude: number): string {
    return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
  }

  showEditMap: boolean = false;
  onEditClick() {
    this.editLocation.emit(this.polePopup);
    this.showEditMap = true;
  }

  notImplementedFullDetailsCim() {
    this.toastr.warning('Full Details for CIM assets are not implemented yet!');
  }
}
